<template>
  <NuxtLayout name="markup" background-class="bg-surface-tertiary">
    <MarkupGenerator :page-data="markupData" :is-page="true" />
  </NuxtLayout>
</template>

<script setup lang="ts">
import { general_setPageTheme } from '~/utils/general/pageThemeClassFromMarkup';
import { ASYNC_KEY_SUBSCRIPTION_PAGE } from '~/models/AsyncDataKeys.model';

const config = useRuntimeConfig();
const route = useRoute();
definePageMeta({
  layout: false,
});

const notificationStore = useNotificationStore();
const { $api } = useNuxtApp();
notificationStore.reset();

const { data: markupData, error } = await useAsyncData(
  ASYNC_KEY_SUBSCRIPTION_PAGE,
  async () => {
    return await $api.categoryModule.getCategory(2);
  },
  {
    transform: cache_addFetchedAtTransform,
    getCachedData: cache_getCachedDataFromServer,
  },
);

if (error.value) {
  notificationStore.setStandardErrorNotification();
}

general_setPageTheme(markupData.value?.PageContent);

const canonicalUrl = `${config.public.apiBaseUrl.replace(/\/$/, '')}${route.fullPath.split('?')[0]}`;

const seoInput = {
  seoData: {
    title: markupData?.value?.MetaTitle,
    description: markupData?.value?.MetaDescription,
    siteName: 'Halebop',
    keywords: markupData?.value?.MetaKeywords,
    canonicalUrl,
  },
  fallBackSeoData: {
    title: 'Byt till nytt mobilabonnemang - Halebop | Halebop.se',
    description:
      'Upptäck våra flexibla mobilabonnemang på Halebop. Skräddarsy ditt abonnemang efter behov och njut av pålitlig täckning och enkelhet. Välkommen till Halebop!',
    siteName: 'Halebop',
    keywords: '',
    canonicalUrl,
  },
};
useCustomSeoMeta(seoInput);
</script>
<style scoped lang="scss"></style>
